import { useEffect, useRef } from 'react'

import { App } from '@capacitor/app'

export const BIOMETRIC_BACKGROUND_LOCK_MS = 15 * 1000

export const useBackgroundLock = (lock: () => void) => {
  const backgroundedAtRef = useRef<number | null>(null)

  useEffect(() => {
    const onBackground = () => {
      if (backgroundedAtRef.current == null) backgroundedAtRef.current = Date.now()
    }

    const onForeground = () => {
      const backgroundedAt = backgroundedAtRef.current
      backgroundedAtRef.current = null
      if (backgroundedAt != null && Date.now() - backgroundedAt >= BIOMETRIC_BACKGROUND_LOCK_MS) lock()
    }

    let removeApp: (() => void) | undefined
    App.addListener('appStateChange', ({ isActive }) => {
      if (isActive) onForeground()
      else onBackground()
    }).then((handle) => {
      removeApp = () => handle.remove()
    })

    const onVisibility = () => {
      if (document.hidden) onBackground()
      else onForeground()
    }
    document.addEventListener('visibilitychange', onVisibility)

    return () => {
      removeApp?.()
      document.removeEventListener('visibilitychange', onVisibility)
    }
  }, [lock])
}
